import React from 'react';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';
import RunbookItems from './items';

import type { RunbookLog } from 'infrastructure/classes/runbook-log';

interface IRunbookContentProps {
  isDataEmpty: boolean;
  data?: RunbookLog;
  formattedUpdatedAt: string | null;
}

const RunBooksContent: React.FC<IRunbookContentProps> = ({
  isDataEmpty,
  data,
  formattedUpdatedAt,
}) => {
  const { t } = useTranslation();
  const name = `${data?.updateByFullName ?? ''}${data?.createdAt ?? ''}`;

  return (
    <>
      {isDataEmpty ? (
        <div data-cy="run-book-content" className={s['empty-data']}>
          {t('labels.noData')}
        </div>
      ) : (
        <>
          <div className={s['updated-by-wrapper']}>
            {data?.notes && (
              <div data-cy="patient-key-note-updated-by">
                {t('labels.electronicallySignedBy')}: <b>{name}</b>
              </div>
            )}
            {formattedUpdatedAt && (
              <div data-cy="run-book-updated-at">
                <b>{formattedUpdatedAt}</b>
              </div>
            )}
          </div>
          <div data-cy="run-book-content-html" className={s['raw-html']}>
            <RunbookItems data={data} />
          </div>
        </>
      )}
    </>
  );
};

export default RunBooksContent;
